import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Flag, Loader2, CheckCircle2 } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../ui/dialog';
import { SEL_API } from '../../lib/selectionShare';

const REASONS = [
  ['gambling_promo', 'Pubblicizza bookmaker o siti di gioco'],
  ['incitement', 'Invita o spinge a scommettere'],
  ['misleading', 'Contenuto ingannevole o vincite garantite'],
  ['other', 'Altro'],
];

// "Segnala" on a shared selection: reason + optional note, lands in Admin → Segnalazioni
export const ReportSelectionButton = ({ code }) => {
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState('');
  const [note, setNote] = useState('');
  const [sending, setSending] = useState(false);

  const send = async () => {
    setSending(true);
    try {
      await axios.post(`${SEL_API}/shared/${code}/report`, { reason, note });
      toast.success('Segnalazione inviata, grazie. La verificheremo al più presto.');
      setOpen(false);
    } catch {
      toast.error('Invio non riuscito, riprova');
    } finally {
      setSending(false);
    }
  };

  return (
    <>
      <button type="button" onClick={() => setOpen(true)} className="flex items-center gap-1.5 px-3 py-1.5 rounded-full border border-white/10 bg-[#1A1A1A] text-gray-400 text-xs font-bold hover:text-red-300 hover:border-red-400/40 transition-colors" data-testid="shared-report-btn">
        <Flag className="w-3.5 h-3.5" /> Segnala
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="bg-[#1A1A1A] border-white/10 text-white max-w-sm" data-testid="report-dialog">
          <DialogHeader>
            <DialogTitle>Segnala questa selezione</DialogTitle>
            <DialogDescription className="text-gray-400 text-xs">Indica il motivo: il nostro team verificherà il contenuto.</DialogDescription>
          </DialogHeader>
          <div className="space-y-2">
            {REASONS.map(([k, label]) => (
              <button key={k} type="button" onClick={() => setReason(k)} data-testid={`report-reason-${k}`}
                className={`w-full text-left px-3 py-2.5 rounded-xl border text-sm flex items-center justify-between gap-2 transition-colors ${reason === k ? 'border-[#F5A623] bg-[#F5A623]/25 text-white font-bold' : 'border-white/10 text-gray-300'}`}>
                {label}
                {reason === k && <CheckCircle2 className="w-4 h-4 text-[#F5A623] shrink-0" />}
              </button>
            ))}
            <textarea value={note} onChange={(e) => setNote(e.target.value)} maxLength={300} rows={2} placeholder="Dettagli (facoltativo)"
              className="w-full bg-[#111] border border-white/10 rounded-xl px-3 py-2 text-sm text-white outline-none focus:border-[#F5A623]/60" data-testid="report-note" />
            <button type="button" onClick={send} disabled={!reason || sending} className="w-full py-2.5 rounded-xl bg-red-500 text-white font-black text-sm disabled:opacity-40 flex items-center justify-center gap-2" data-testid="report-submit">
              {sending && <Loader2 className="w-4 h-4 animate-spin" />} Invia segnalazione
            </button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ReportSelectionButton;
